import { createSelector } from 'reselect';

const getPrivs = (state) => state.formView.privs;

export const getCanEditForm = createSelector([getPrivs], (privs) => {
  if (!privs) return true;
  return privs.modify;
});
